import {createSlice} from '@reduxjs/toolkit';
import {SortDirection as SortDirections} from 'src/openapi/admin/models/SortDirection';

import {DEFAULT_PAGINATION} from './constants';

import type {CacheKeys, SearchCriteria, SortCriteria} from './typedef';
import type {Draft, PayloadAction} from '@reduxjs/toolkit';
import type {Pagination} from 'src/openapi/admin/models/Pagination';


export const getCachedTableStateSlice = <SearchFields, SortFields, Filters>(
    name: string,
    defaultSortField?: SortFields,
    defaultPagination?: Pagination,
    defaultSortDirection?: SortDirections,
) => createSlice({
    name,
    initialState: {
        searchCriteria: {} as SearchCriteria<SearchFields>,
        sortCriteria: {
            field: defaultSortField,
            direction: defaultSortDirection || SortDirections.ASC,
        },
        pagination: defaultPagination || DEFAULT_PAGINATION,
        filters: {} as SearchCriteria<Filters>,
    } as CacheKeys<SearchFields, SortFields, Filters>,
    reducers: {
        clearData: state => {
            state.searchCriteria = {} as Draft<SearchCriteria<SearchFields>>;
            state.sortCriteria = {
                field: defaultSortField as Draft<SortFields>,
                direction: defaultSortDirection || SortDirections.ASC,
            };
            state.pagination = defaultPagination || DEFAULT_PAGINATION;
            state.filters = {} as Draft<SearchCriteria<Filters>>;
        },
        setSortCriteria: (state, action: PayloadAction<SortCriteria<SortFields>>) => {
            state.sortCriteria = action.payload as Draft<SortCriteria<SortFields>>;
        },
        setCurrentPage: (state, action: PayloadAction<number>) => {
            state.pagination.currentPage = action.payload;
        },
        setPageSize: (state, action: PayloadAction<number>) => {
            state.pagination.pageSize = action.payload;
            state.pagination.currentPage = 1;
        },
        setSearchCriteria: (state, action: PayloadAction<SearchCriteria<SearchFields>>) => {
            state.searchCriteria = action.payload as Draft<SearchCriteria<SearchFields>>;
            state.pagination.currentPage = DEFAULT_PAGINATION.currentPage;
        },
        setFilters: (state, action: PayloadAction<SearchCriteria<Filters>>) => {
            state.filters = action.payload as Draft<SearchCriteria<Filters>>;
            state.pagination.currentPage = DEFAULT_PAGINATION.currentPage;
        },
    },
});
